import React from 'react';
import { stats } from '../data/mock';

const Stats = () => {
  return (
    <section className="py-16 bg-[#232323]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center lg:text-left">
              <div className="font-display text-4xl lg:text-5xl font-bold text-[#38FF62] mb-2">
                {stat.value}
              </div>
              <div className="font-mono text-sm uppercase tracking-wider text-white mb-1">
                {stat.label}
              </div>
              <div className="font-body text-sm text-[rgba(255,255,255,0.5)]">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;